import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import {
  EVENT_LIST_CACHE_FIELDS,
  ORGANIZATION_PEOPLE_CACHE_FIELDS,
} from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

const JOIN_CACHE_FIELDS = [
  ...EVENT_LIST_CACHE_FIELDS,
  'event_by_pk',
  ...ORGANIZATION_PEOPLE_CACHE_FIELDS,
  'person',
  'person_aggregate',
  'person_team',
  'person_team_aggregate',
  'team',
  'team_by_pk',
];

export function invalidateJoinFields(cache: FieldInvalidationCache) {
  invalidateFields(JOIN_CACHE_FIELDS, cache);
}

export default function accept_invite_entry(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateJoinFields(cache);
}
